// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import SafetyHookResourceViewModel from '../../../../viewModel/resource/SafetyHookResourceViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import SafetyHookResourceListResultViewModel from '../../../../viewModel/resource/SafetyHookResourceListResultViewModel';
import SafetyHookResourceListResultDTO from '../../dto/resource/SafetyHookResourceListResultDTO';

export default abstract class SafetyHookResourceListResultModel extends BaseModel<SafetyHookResourceListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, SafetyHookResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
